import routes from './routes'

export const STEPS = {
  ZIP_CODE: 'zip_code',
  INFO: 'info',
  QUALIFICATION: 'qualification',
  PLAN_RANK: 'plan_rank',
  RANK: 'rank',
  PLANS: 'plans',
  DETAILS: 'details',
  FINALIZE: 'finalize',
  SUCCESS: 'success'
}

export const REJECT_ENROLLMENT_REASONS = {
  NON_VALID_STATE: 'noValidState',
  NON_ELIGIBLE: 'noEligible'
}

export const HOME_SCREEN = 'homeScreen'
export const ROUTE_STEP = {
  [routes.ROOT]: STEPS.ZIP_CODE,
  [routes.ENROLL_INFO]: STEPS.INFO,
  [routes.ENROLL_QUALIFICATION]: STEPS.QUALIFICATION,
  [routes.ENROLL_PLAN_RANK]: STEPS.PLAN_RANK,
  [routes.ENROLL_PLAN_RANK]: STEPS.RANK,
  [routes.ENROLL_PLANS]: STEPS.PLANS,
  [routes.ENROLL_PLAN]: STEPS.PLANS,
  [routes.ENROLL_MEMBER_DETAILS]: STEPS.DETAILS,
  [routes.ENROLL_FINALIZE]: STEPS.FINALIZE,
  [routes.ENROLL_SUCCESS]: STEPS.SUCCESS
}
const filterOEPRoutes = isOEP => route => {
  if (route === routes.ENROLL_QUALIFICATION) {
    // in case you wonder what it isOEP:
    // in oep (open enrollment period) we should skip qualification step
    // in sep (special enrollment period) we should show qualification step
    return !isOEP
  }
  return true
}

export const getBackRoutes = ({ currentRoute, isOEP }) => {
  const allRoutes = [
    routes.ENROLL_INFO,
    routes.ENROLL_QUALIFICATION,
    routes.ENROLL_PLAN_RANK,
    routes.ENROLL_PLANS,
    routes.ENROLL_MEMBER_DETAILS,
    routes.ENROLL_FINALIZE
  ].filter(filterOEPRoutes(isOEP))

  const index = allRoutes.findIndex(
    fullroute => fullroute.split('/').pop() === currentRoute
  )
  if (index === -1) return []
  return allRoutes.slice(0, index)
}

export const concatUrlSearchParams = params => route => {
  const searchParams = new URLSearchParams()
  Object.keys(params).forEach(key => searchParams.append(key, params[key]))
  return `${route}?${searchParams.toString()}`
}
